import { atom } from 'recoil';

export const gameSoundOnState = atom({
  key: 'gameSoundOnState',
  default: true,
});

export const gameSoundVolumeState = atom({
  key: 'gameSoundVolumeState',
  default: 0.5,
});
